import React, { useEffect, useState } from 'react'
import Address from './SubTab/Address'
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
import { Formik, useFormik } from 'formik';
import { toast } from 'react-toastify';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import { useDispatch, useSelector } from 'react-redux';
import { getJobOrderCustomsDetails, getJobOrderCustomsHouseList, getJobOrderEximSchemeList } from '../../../../../Redux/action/Joborder/JoborderAction';

const CustomsTab = ({ token, user_id, b64id }) => {

    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(true);
    const [disableSubmit, setDisableSubmit] = useState(false);



    useEffect(() => {
        if (token && user_id) {
            dispatch(getJobOrderCustomsHouseList(token, user_id));
            dispatch(getJobOrderEximSchemeList(token, user_id));
            if (b64id) {
                let id = atob(b64id);
                if (id) {
                    dispatch(getJobOrderCustomsDetails(token, user_id, id));
                }
            }
        }
    }, [token, user_id, b64id]);


    const refreshCustomsData = () => {
        if (token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getJobOrderCustomsDetails(token, user_id, id));
            }

        }
    }

    let {

        loadingJobOrderCustomsHouseList,
        JobOrderCustomsHouseList,
        JobOrderCustomsHouseListError,

        loadingJobOrderEximSchemeList,
        JobOrderEximSchemeList,
        JobOrderEximSchemeListError,

        loadingJobOrderCustomsDetail,
        JobOrderCustomsDetailError,
        JobOrderCustomsDetail,
    } = useSelector(state => state?.JoborderReducer);


    const [customHouseOptions, setCustomHouseOptions] = useState([]);
    const [loadingCustomHouse, setLoadingCustomHouse] = useState(false);
    const [eximSchemeOptions, setEximSchemeOptions] = useState([]);
    const [loadingEximScheme, setLoadingEximScheme] = useState(false);


    useEffect(() => {
        if (loadingJobOrderCustomsHouseList) {
            setLoadingCustomHouse(true);
        } else {
            setLoadingCustomHouse(false);
        }

        if (JobOrderCustomsHouseList) {
            let arr = [];
            JobOrderCustomsHouseList.map(val => arr.push({ value: val.id, label: val.name }));
            setCustomHouseOptions(arr);
        }

    }, [loadingJobOrderCustomsHouseList, JobOrderCustomsHouseList]);

    useEffect(() => {
        if (loadingJobOrderEximSchemeList) {
            setLoadingEximScheme(true);
        } else {
            setLoadingEximScheme(false);
        }

        if (JobOrderEximSchemeList) {
            let arr = [];
            JobOrderEximSchemeList.map(val => arr.push({ value: val.id, label: val.name }));
            setEximSchemeOptions(arr);
        }
    }, [loadingJobOrderEximSchemeList, JobOrderEximSchemeList])


    const initialValues = {
        job_order_id: "",
        custom_house_id: "",
        exim_scheme_id: "",
        document_type: "Any",
        remarks: "",
        rms_Clg: "Any",
    };


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values) => {
            // console.log(values);
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.job_order_id = atob(b64id);
                axios.post(`${adminMainUrl}/api/jobOrder/custom/add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refreshCustomsData();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error);
                        let msg = "Internal Server Error!"
                        if(error.response){
                            if(error.response.data){
                                if(error.response.data.msg){
                                    msg = error.response.data.msg;
                                }
                            }
                        }
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (loadingJobOrderCustomsDetail) {
            setShowLoader(true)
        } else {
            setShowLoader(false)
        };

        if (JobOrderCustomsDetail) {
            formik.setFieldValue("custom_house_id", Number(JobOrderCustomsDetail?.custom_house_id));
            formik.setFieldValue("exim_scheme_id", Number(JobOrderCustomsDetail?.exim_scheme_id));
            formik.setFieldValue("document_type", JobOrderCustomsDetail?.document_type);
            formik.setFieldValue("remarks", JobOrderCustomsDetail?.remarks);
            formik.setFieldValue("rms_Clg", JobOrderCustomsDetail?.rms_Clg);
        }

    }, [loadingJobOrderCustomsDetail, JobOrderCustomsDetailError, JobOrderCustomsDetail,]);

    const customStyles = {
        control: (base) => ({
          ...base,
          height: 29,
          minHeight: 29,
          display: 'flex',
          alignItems: 'center',
        }),
        placeholder: (base) => ({
          ...base,
          display: 'flex',
          alignItems: 'center',
          fontSize: '12px',
          fontWeight: "600",
          color: '#808080',
        }),
        menu: (base) => ({
          ...base,
          fontSize: '12px',
        }),
        option: (base) => ({
          ...base,
          fontSize: '12px',
        }),
        singleValue: (base) => ({
          ...base,
          fontSize: '12px',
          display: 'flex', // Ensure singleValue aligns center vertically
          alignItems: 'center',
        }),
      };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="row border-bottom-2 pb-3">
                    <div className="col-md-12">
                        <div className="card px-3 py-2">
                            <div className="row">

                                <div className="col-md-6 mt-3">
                                    <label htmlFor="Shipper" className='form-label '>Custom House:</label>
                                    <Select
                                        id="Shipper"
                                        className='custom-selector w-100'
                                        options={customHouseOptions}
                                        styles={customStyles}
                                        name="custom_house_id"
                                        onChange={option => {
                                            formik.setFieldValue('custom_house_id', option.value);
                                        }}
                                        value={customHouseOptions.find(option => option.value === formik.values.custom_house_id) || null}
                                    />
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="Shipper" className='form-label '>Exim Scheme:</label>
                                    <Select
                                        id="Shipper"
                                        className='custom-selector w-100'
                                        options={eximSchemeOptions}
                                        styles={customStyles}
                                        name="exim_scheme_id"
                                        onChange={option => {
                                            formik.setFieldValue('exim_scheme_id', option.value);
                                        }}
                                        value={eximSchemeOptions.find(option => option.value === formik.values.exim_scheme_id) || null}
                                    />
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="Shipper" className='form-label '>Document Type:</label>
                                    <select className='form-control form-control-sm'
                                        name='document_type'
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.document_type}
                                    >
                                        <option value="">-</option>
                                        <option value="Any">Any</option>
                                        <option value="In-Bond">In-Bond</option>
                                        <option value="Ex-Bond">Ex-Bond</option>
                                        <option value="Home">Home</option>
                                    </select>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="Shipper" className='form-label '>RMS Clg:</label>
                                    <select className='form-control form-control-sm'
                                        name='rms_Clg'
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.rms_Clg}
                                    >
                                        <option value="">-</option>
                                        <option value="Any">Any</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>
                                <div className="col-md-12 mt-3">
                                    <label htmlFor="Shipper" className='form-label '>Remarks</label>
                                    <textarea
                                        rows={3}
                                        className='form-control'
                                        name='remarks'
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.remarks}
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row d-flex justify-content-end my-2">
                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                        </button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default CustomsTab